import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { JobContentFragmentDoc } from '../../fragments/generated/JobContent';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type JobsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.JobsFilters>;
}>;


export type JobsQuery = { jobs: { edges?: Array<{ node: { id: string, createdAt: string, jobScheduleId: string, status: Types.JobEntityStatusEnum, mediaUrls: Array<{ fileName?: string | null }>, meta?: { skillsImportMetadata?: { createdSkillsCount: number } | null, bulkUnAssignLearnerMetadata?: { unAssignableLearnersCount: number, totalLearnersCount: number } | null } | null, input?: { offlineEventAttendanceImportInput?: { eventId: string } | null, quizQuestionImportInput?: { quizId?: string | null } | null, bulkUnAssignContentPropsInput?: { entityId: string, userIds?: Array<string> | null, learnerGroupIds?: Array<string> | null } | null, forceCompleteContentInput?: { userIds: Array<string>, entityIds: Array<string> } | null, downloadJourneyPerformancesTemplateInput?: { journeyId: string, phaseId: string } | null, bulkImportJourneyPerformancesInput?: { journeyId: string, phaseId: string } | null } | null } }> | null } };


export const JobsDocument = /*#__PURE__*/ gql`
    query jobs($filters: JobsFilters) {
  jobs(filters: $filters) {
    edges {
      node {
        ...JobContent
      }
    }
  }
}
    ${JobContentFragmentDoc}`;

export function useJobsQuery(options?: Omit<Urql.UseQueryArgs<JobsQueryVariables>, 'query'>) {
  return Urql.useQuery<JobsQuery, JobsQueryVariables>({ query: JobsDocument, ...options });
};